/** Missing-row guidance only. Presence of rows does not certify a complete P&L. */
export function JournalClosedTradeGuidance({ status, types }: { readonly status: string; readonly types: readonly string[] }) {
  if (status !== 'closed') return null;
  const hasEntry = types.includes('entry'), hasExit = types.includes('exit');
  if (hasEntry && hasExit) return null;
  const missing = !hasEntry && !hasExit ? 'No actual entries or exits are recorded.' : !hasEntry ? 'No actual entry is recorded.' : 'No actual exit is recorded.';
  return <p className="kairos-trade-form__section-copy" role="note" aria-label="P&L guidance">
    {missing} You can save these trade details, but calculated P&amp;L will stay unavailable. Add the actual entry and exit prices, quantities and times. Opening and closing times alone do not record fills.
  </p>;
}
